import React, { useState } from 'react';
import FormGroup from '../FormGroup';
import classNames from 'classnames/bind';
import styles from './Form.module.scss';

const cx = classNames.bind(styles);

function TipForm({ keyForm, titleBtn = 'Submit', data = {}, types = [], handleSubmit = () => {}, fileInputRef }) {
  const [selectedType, setSelectedType] = useState(String(data.type_id) || '');

  const handleChange = (e) => {
    setSelectedType(e.target.value);
  };

  return (
    <form className={cx('create-post')} key={keyForm} encType="multipart/form-data" onSubmit={handleSubmit}>
      <FormGroup title="Tiêu đề" name="title" value={data?.title} placeholder="Tiêu đề" />
      <FormGroup title="Giới thiệu" name="introduce" value={data?.introduce} placeholder="Giới thiệu" />
      <FormGroup title="Nội dung" name="content" value={data?.content} type="textarea" />
      <FormGroup title="Tác giả" name="author_id" value={data?.author_id || 'Quyen'} placeholder="Tác giả" readOnly />
      <div className={cx('form-group')}>
        <label>Loại tip</label>
        <select className={cx('select')} name="type_id" value={selectedType} onChange={handleChange} required>
          <option value="" disabled>
            Chọn loại tip
          </option>
          {types.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
      </div>
      <button type="submit">{titleBtn}</button>
    </form>
  );
}

export default TipForm;
